







import { gql } from 'graphql-tag';
import { Component, mixins } from 'nuxt-property-decorator';

import { blockableBlockColorFragment, blockColorMixin } from '@/composables/block-color';

import { AccordionSection } from '@/components/block/Accordion.vue';

import { PageBlockMixin } from '@/modules/cms';
import { FaqBlockDataFragment } from '@/graphql/generated';

@Component({
  graphqlData: gql`
    fragment FaqBlockData on FaqBlock {
      id
      title
      items {
        question
        answer
      }
      ...BlockColor
    }

    ${blockableBlockColorFragment}
  `,
})
export default class FaqBlock extends mixins(PageBlockMixin<FaqBlockDataFragment>(), blockColorMixin) {
  get faqItems (): AccordionSection[] {
    return this.data.items.map(item => ({
      title: item.question,
      content: item.answer,
    }));
  }
}
